/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class CombinedRoute extends Route {
  queryParams = {
    currentMilestoneId: {
      refreshModel: false,
    },
  };

  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');
    let triangulation = this.modelFor('group.triangulation');

    return hash({
      group,
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        groupId: group.id,
      }),
      goalSubjects: triangulation.subjects,
      milestones: triangulation.milestones,
      milestoneSets: triangulation.milestoneSets,
      expectations: this.store.findAll('milestones/expectation'),
      levels: this.store.findAll('milestones/level'),
      progressions: this.store.query('milestones/progression', {
        groupId: group.id,
        latest: true,
        type: ProgressionType.PROGRESSION,
      }),
    });
  }

  afterModel() {
    super.afterModel(...arguments);
    let params = this.paramsFor('group.triangulation.combined');
    if (!isEmpty(params) && !isEmpty(params.currentMilestoneId)) {
      let milestone = this.store.peekRecord(
        'milestones/milestone',
        params.currentMilestoneId,
      );
      let milestoneSet = { label: 'Default Milestones', isDefault: true };
      if (!isEmpty(milestone) && !isEmpty(milestone.set_id)) {
        milestoneSet = milestone.milestoneSet;
      }
      this.controllerFor('group.triangulation').set(
        'selectedMilestoneSet',
        milestoneSet,
      );
    }
  }
}
